import { Button } from '@ahmdigital/ui';
import { find } from 'lodash/fp';
import { useDispatch } from 'react-redux';
// @ts-expect-error - Automatic, Please fix when editing this file
import liveChatActions from '@ahmdigital/livechat/lib/actions';
import React, { useCallback } from 'react';
import styled from 'styled-components';

import { ContactDetailsContent } from '../../../insurance/types';
import { DRAWER_IDS } from '../../../../ahm-constants/ui';
import { optionConstantIds } from '../../../contact-us/components/contact-options';
import { TableOfContentsItem } from '../../../../types/sanityInternal';
import constants from '../../../../ahm-constants';
import Contact from '../../../insurance/components/contact-details';
import DrawerActions from '../../../../actions/drawer';
import formatContactOptions, {
  CONTACT_OPTION_ID,
} from '../../../contact-us/components/decision-tree/options/utils/format-contact-options';
import liveChatConfig from '../../../../utils/livechat';
import LiveChatStatus from '../../../../components/live-chat/live-chat-status';
import useGetAllPlaceholders from '../../../../components/offers/logic/use-get-all-placeholders';
import useLiveChat from '../../../../components/live-chat/use-live-chat';

const ButtonWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding: 1rem 0;

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    align-items: flex-end;
    flex-direction: row;
  }
`;

type StyledButtonProps = {
  isLink?: boolean;
};

const StyledButton = styled(Button)<StyledButtonProps>`
  margin-right: 1rem;
  width: 100%;
  padding-top: ${({ isLink }) => (isLink ? '1.275rem' : '0.75rem')};

  &:first-child {
    margin-bottom: 1rem;
  }

  @media (min-width: ${({ theme }) => theme.media.xs}) {
    width: 12rem;

    &:first-child {
      margin-bottom: 0;
    }
  }
`;

type ContactDetailsProps = {
  items: TableOfContentsItem[];
  name: string;
};
const ContactDetails = ({ items, name }: ContactDetailsProps) => {
  const dispatch = useDispatch();
  const { placeholders } = useGetAllPlaceholders();
  const openGetACallBackDrawer = useCallback(() => {
    DrawerActions.openDrawer(DRAWER_IDS.GET_A_CALL_BACK)(dispatch);
  }, [dispatch]);
  const launchLivechat = useCallback(() => {
    liveChatActions.launch(liveChatConfig)(dispatch);
  }, [dispatch]);
  const { isAbcSupportedAndAvailable, isOnline, messageId } = useLiveChat();

  const formattedContactOptions = formatContactOptions({
    id: CONTACT_OPTION_ID.LOOKING_TO_JOIN,
    items,
    placeholders,
    title: name,
  });

  const phoneContact = find((item: TableOfContentsItem) => item.item.type === 'phone', items);
  const phoneContactItem = phoneContact?.item;
  const messageOption = find(
    { contactOptionId: optionConstantIds.lookingToJoinChatBox },
    formattedContactOptions.options,
  );

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'contactOptionData' does not exist on type '{ contactOptionId: string; }'. Did you mean 'contactOptionId'?
  const offline = messageOption?.contactOptionData?.offline;
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'contactOptionData' does not exist on type '{ contactOptionId: string; }'. Did you mean 'contactOptionId'?
  const online = messageOption?.contactOptionData?.online;

  const getMessageUsButton = () => {
    if (isAbcSupportedAndAvailable) {
      return (
        <StyledButton
          isLink
          to={`${constants.URLS.THIRD_PARTY.APPLE_BUSINESS_CHAT}${messageId}`}
          variant={['border', 'smallPadding', 'white']}
        >
          {isOnline ? online.buttonText : offline.buttonText}
        </StyledButton>
      );
    }

    if (isOnline) {
      return (
        <StyledButton onClick={launchLivechat} variant={['border', 'smallPadding', 'white']}>
          {online.buttonText}
        </StyledButton>
      );
    }

    return (
      <StyledButton isLink to={offline.buttonUrl} variant={['border', 'smallPadding', 'white']}>
        {offline.buttonText}
      </StyledButton>
    );
  };

  const customActionsComponent = (
    <>
      <LiveChatStatus isOnline={isOnline} />
      <ButtonWrapper>
        {offline && online && getMessageUsButton()}
        <StyledButton onClick={openGetACallBackDrawer} variant={['border', 'smallPadding', 'white']}>
          Get a call back
        </StyledButton>
      </ButtonWrapper>
    </>
  );

  const contactProps = { contact: phoneContactItem, customActionsComponent, name } as ContactDetailsContent;
  return <Contact {...contactProps} />;
};

export default ContactDetails;
